import React from 'react';
import PropType from 'prop-types';
import getLocation from '../utils/getLocation';

const cities = getLocation();

const CitySelect = ({ value, onChange }) => (
  <select value={value} onChange={onChange} className="location-dropdown-sel">
    {
      cities.map((el, ind) => <option key={ind} value={el.id}>{el.city}, {el.state}</option>)
    }
  </select>
);
CitySelect.PropType = {
  value: PropType.string.isRequired,
  onChange: PropType.func.isRequired
}
export default CitySelect;